module.exports = __webpack_public_path__ + "img/Versorgungstrupp_Verbrauchsgüter.09241bdc.svg";